import React from 'react';
import {connect} from 'react-redux';
import {
    Table, Input, Button, Icon, Row, Col, Modal, Form
} from 'antd';
import {FormattedMessage} from "react-intl";
import Highlighter from 'react-highlight-words';
import SupplierForm from "./supplier-form";
import ReactSVG from 'react-svg';
import {supplierSelected} from './../../actions'
import ShowListItem from '../../components/show-list-item/ShowListItem';

const WrappedSupplierForm = Form.create({name: 'supplier'})(SupplierForm);

class SupplierTable extends React.Component {
    state = {
        searchText: '',
        selectedElement: {},
        currentIndex: 0
    };

    async componentDidMount() {
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };
    closeModal = () => {
        this.setState({
            visible: false,
        });
    };

    handleOk = (e) => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    handleCancel = (e) => {
        console.log(e);
        this.setState({
            visible: false,
        });
    };

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
                             setSelectedKeys, selectedKeys, confirm, clearFilters,
                         }) => (
            <div style={{padding: 8}}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{width: 188, marginBottom: 8, display: 'block'}}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{width: 90, marginRight: 8}}
                >
                    Sök
                </Button>
                <Button
                    onClick={() => this.handleReset(clearFilters)}
                    size="small"
                    style={{width: 90}}
                >
                    Nollställ
                </Button>
            </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>,
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: (text) => (
            <Highlighter
                highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text ? text.toString() : ""}
            />
        ),
    });

    handleSearch = (selectedKeys, confirm) => {
        confirm();
        this.setState({searchText: selectedKeys[0]});
    };

    handleReset = (clearFilters) => {
        clearFilters();
        this.setState({searchText: ''});
    };

    itemSelected = (event, record, rowIndex) => {
        this.setState({selectedElement: record, currentIndex: rowIndex}, () => {
            if (this.form !== undefined) {
                this.form.resetFields();
            }
        });

        this.state = {...this.state, currentIndex: rowIndex};
        this.props.onCompanySelected(record);
    };

    closeSelected = () => {
        this.props.onCompanySelected(null);
    };

    onPrevious = () => {
        let newIndex = this.state.currentIndex - 1;
        if (newIndex < 0) {
            newIndex = this.props.suppliers.length - 1;
        }

        this.state = {...this.state, currentIndex: newIndex};

        let prevRecord = this.props.suppliers[newIndex];
        this.props.onCompanySelected(prevRecord);
    };

    onNext = () => {
        let newIndex = this.state.currentIndex + 1;
        if (newIndex > this.props.suppliers.length - 1) {
            newIndex = 0;
        }

        this.state = {...this.state, currentIndex: newIndex};
        let nextRecord = this.props.suppliers[newIndex];
        this.props.onCompanySelected(nextRecord);
    };

    isEditMode = () => {
        return true;
    };

    modalTitle = () => {
        if (this.isEditMode()) {
            return <FormattedMessage id="editSupplier"/>
        } else {
            return <FormattedMessage id="newSupplier"/>
        }
    };

    setFormRef = (form) => {
        this.form = form;
    };

    setTableRef = (table) => {
        this.table = table;
    };

    renderTable = () => {
        if (!this.props.suppliers) {
            return (<div/>);
        }

        const columns = [{
            title: <FormattedMessage id="company"/>,
            dataIndex: 'company',
            key: 'company',
            width: '30%',
            ...this.getColumnSearchProps('company'),
            sorter: (a, b) => ('' + a.company).localeCompare(b.company),
            sortDirections: ['descend', 'ascend'],
        }, {
            title: <FormattedMessage id="name"/>,
            dataIndex: 'name',
            key: 'name',
            width: '30%',
            ...this.getColumnSearchProps('name'),
            sorter: (a, b) => {
                return ('' + a.name).localeCompare(b.name)
            },
            sortDirections: ['descend', 'ascend']
        }, {
            title: <FormattedMessage id="email"/>,
            dataIndex: 'email',
            key: 'email',
            width: '30%',
            ...this.getColumnSearchProps('email'),
            sorter: (a, b) => ('' + a.email).localeCompare(b.email),
            sortDirections: ['descend', 'ascend'],
        }, {
            title: <FormattedMessage id="contact_person"/>,
            dataIndex: 'contact_name',
            key: 'contact_name',
            width: '20%',
            ellipsis: true,
            ...this.getColumnSearchProps('contact_name'),
            sorter: (a, b) => ('' + a.contact_name).localeCompare(b.contact_name),
            sortDirections: ['descend', 'ascend'],
        }, {
            title: 'Redigera',
            dataIndex: '',
            key: 'x',
            width:'15%',
            render: (text, record) => (<Icon type="edit" theme="outlined" onClick={(e) => {
                e.preventDefault();
                this.showModal()
            }}/>)
        }];

        const {selectedSupplier, onFormPosted, ...remainingProps} = this.props;
        return (<div>
            <Modal
                footer={null}
                title={this.modalTitle()}
                visible={this.state.visible}
                onCancel={this.handleCancel}
            >
                <WrappedSupplierForm
                    isEditMode
                    ref={this.setFormRef}
                    supplier={selectedSupplier}
                    onFormPosted={onFormPosted}
                    closeModal={this.closeModal}
                    closeCompanyModal={this.props.closeCompanyModal} showCompanyModal={this.props.showCompanyModal}
                />
            </Modal>
            <Table
                columns={columns}
                dataSource={this.props.suppliers}
                {...remainingProps}
                ref={this.setTableRef}
                style={{
                            minWidth: '900px',
                            maxWidth: '100%',
                            tableLayout: 'fixed',
                        }}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: (event) => {
                            this.itemSelected(event, record, rowIndex);
                        }, // click row
                        onDoubleClick: (event) => {
                        }, // double click row
                        onContextMenu: (event) => {
                        }, // right button click row
                        onMouseEnter: (event) => {
                        }, // mouse enter row
                        onMouseLeave: (event) => {
                        }, // mouse leave row
                    };
                }}/>

            {selectedSupplier &&
            <ShowListItem
                heading={selectedSupplier.company}
                onEdit={this.showModal}
                onPrevious={this.onPrevious}
                onNext={this.onNext}
                onClose={this.closeSelected}
                rows={[
                    [
                        {
                            label: 'Namn',
                            value: `${selectedSupplier.first_name || ''}${selectedSupplier.last_name ? ' ' + selectedSupplier.last_name : ''}`
                        },
                        {
                            label: 'Kontaktperson på reitan',
                            value: selectedSupplier.contact_name
                        }
                    ],
                    [
                        {
                            label: 'E-post',
                            value: selectedSupplier.email
                        },
                        {
                            label: 'Identifieringsnivå',
                            value: selectedSupplier.identification_requirement_level_string
                        }
                    ],
                    [
                        {
                            label: 'Telefonnummer',
                            value: selectedSupplier.phone_number
                        }
                    ]
                ]}
            />
            }
        </div>);
    };

    render() {
        return (this.renderTable());
    }
}

const mapStateToProps = ({supplier}) => ({
    selectedSupplier: supplier.supplierPage.selectedSupplier,
    suppliers: supplier.suppliers,
});

const mapDispatchToActions = {
    onCompanySelected: supplierSelected
};

export default connect(mapStateToProps, mapDispatchToActions)(SupplierTable);